import { BorderedWrapper } from 'components/shared';
import { StyledAccuralSchedule } from './styles';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import { AccuralDiagram } from 'components/AccuralDiagram';
import {useSelector} from 'react-redux';
import {selectAccruals} from '../../store/slices/userAccrualSlice';
interface IAccuralScheduleProps {
  children?: React.ReactNode;
}
export const AccuralSchedule = ({ children }: IAccuralScheduleProps) => {
  const { t } = useTranslation();
  let tempAccruedValue = 0;
  const creditFixTime = '00:00 GMT-1';

  const componentRef = useRef<HTMLDivElement>(null);
  const [hashrateDiagramContainerWidth, setHashrateDiagramContainerWidth] = useState(50);
  const getDaysCount = (width: number) => {
    if (width >= 1415) return 12;
    if (width >= 1031) return 11;
    if (width >= 579) return 6;
    return 5;
  };
  const daysCount = getDaysCount(hashrateDiagramContainerWidth);
  const { accrualsGraph } = useSelector(selectAccruals);
  for (const accrual of accrualsGraph) {
    const now = new Date();

    const from = new Date();
    from.setDate(now.getDate() - daysCount);

    const accrualDate = new Date(accrual.date);

    const inRange = accrualDate >= from && accrualDate <= now;
    if (inRange) {
      tempAccruedValue += Number(accrual.amount);
    }
  }
  const totalAccruedValue = (tempAccruedValue.toFixed(10)).replace(/\.?0+$/, '');

  useEffect(() => {
    setHashrateDiagramContainerWidth(componentRef.current!.clientWidth);
    if (componentRef.current) {
      window.addEventListener('resize', () => {
        const currentWidth = componentRef.current?.clientWidth;
        if (currentWidth !== hashrateDiagramContainerWidth) {
          setHashrateDiagramContainerWidth((prev) =>
            componentRef.current ? componentRef.current.clientWidth : prev,
          );
        }
      });
    }

    return () => {
      window.removeEventListener('resize', () => {});
    };
  }, []);

  return (
    <StyledAccuralSchedule className="accural-schedule">
      <BorderedWrapper>
        <h4 className="accural-schedule-heading">{t('accuralSchedule.heading')}</h4>
        <p className="accural-schedule-credits-fixed">
          {t('accuralSchedule.createdFixed')} {creditFixTime}
        </p>
        <div className="accural-schedule-diagram" ref={componentRef}>
          <AccuralDiagram containerWidth={hashrateDiagramContainerWidth} />
        </div>
        <p className="accural-schedule-total-accured">
          <span className="accural-schedule-total-accured__title">
            {t('accuralSchedule.totalAccured')}
          </span>
          <span className="accural-schedule-total-accured__value">{totalAccruedValue}</span>
        </p>
      </BorderedWrapper>
      {children}
    </StyledAccuralSchedule>
  );
};
